// tickets.json

import { v4 as uuidv4 } from "uuid";
import { CarouselImg1, CarouselImg2, CarouselImg3, CarouselImg4, CarouselImg5, TicketCard1, TicketCard2, TicketCard3, TicketCard4, TicketCard5, TicketCard6 } from './assets'


const ticketsData = [
  {
    "id": uuidv4(),
    "imageSrc": TicketCard1,
    "title": "England vs Pakistan | WTC",
    "date": "16th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard4,
    "title": "India vs Afghanistan | WT20",
    "date": "16th March 2023",
    "country": "AFG",
    "price": 11
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard3,
    "title": "England vs India | WTC",
    "date": "19th March 2023",
    "country": "IND",
    "price": 16
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard6,
    "title": "South Africa vs India | ODI",
    "date": "16th March 2023",
    "country": "SA",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard2,
    "title": "West Indies vs India | WTC",
    "date": "20th March 2023",
    "country": "WI",
    "price": 8
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard5,
    "title": "Afghanistan vs New Zealand | WTC",
    "date": "18th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard1,
    "title": "England vs Pakistan | WTC",
    "date": "16th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard4,
    "title": "India vs Afghanistan | WT20",
    "date": "16th March 2023",
    "country": "AFG",
    "price": 11
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard3,
    "title": "England vs India | WTC",
    "date": "19th March 2023",
    "country": "IND",
    "price": 16
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard6,
    "title": "South Africa vs India | ODI",
    "date": "16th March 2023",
    "country": "SA",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard2,
    "title": "West Indies vs India | WTC",
    "date": "20th March 2023",
    "country": "WI",
    "price": 8
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard5,
    "title": "Afghanistan vs New Zealand | WTC",
    "date": "18th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard1,
    "title": "England vs Pakistan | WTC",
    "date": "16th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard4,
    "title": "India vs Afghanistan | WT20",
    "date": "16th March 2023",
    "country": "AFG",
    "price": 11
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard3,
    "title": "England vs India | WTC",
    "date": "19th March 2023",
    "country": "IND",
    "price": 16
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard6,
    "title": "South Africa vs India | ODI",
    "date": "16th March 2023",
    "country": "SA",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard2,
    "title": "West Indies vs India | WTC",
    "date": "20th March 2023",
    "country": "WI",
    "price": 8
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard5,
    "title": "Afghanistan vs New Zealand | WTC",
    "date": "18th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard1,
    "title": "England vs Pakistan | WTC",
    "date": "16th March 2023",
    "country": "ENG",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard4,
    "title": "India vs Afghanistan | WT20",
    "date": "16th March 2023",
    "country": "AFG",
    "price": 11
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard3,
    "title": "England vs India | WTC",
    "date": "19th March 2023",
    "country": "IND",
    "price": 16
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard6,
    "title": "South Africa vs India | ODI",
    "date": "16th March 2023",
    "country": "SA",
    "price": 10
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard2,
    "title": "West Indies vs India | WTC",
    "date": "20th March 2023",
    "country": "WI",
    "price": 8
  },
  {
    "id": uuidv4(),
    "imageSrc": TicketCard5,
    "title": "Afghanistan vs New Zealand | WTC",
    "date": "18th March 2023",
    "country": "ENG",
    "price": 10
  }
];


export default ticketsData;
